var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_54",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3146 24.2676H2.6854C1.60679 24.2676 0.732422 23.3932 0.732422 22.3146V2.68541C0.732422 1.6068 1.60679 0.73243 2.6854 0.73243H22.3146C23.3932 0.73243 24.2676 1.60679 24.2676 2.68546V22.3146C24.2676 23.3932 23.3932 24.2676 22.3146 24.2676Z",
    stroke: "#163235",
    strokeWidth: 2.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.732422 6.64062H24.2188",
    stroke: "#163235",
    strokeWidth: 2.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0215 3.71094C22.0215 4.11543 21.6936 4.44336 21.2891 4.44336C20.8846 4.44336 20.5566 4.11543 20.5566 3.71094C20.5566 3.30645 20.8846 2.97852 21.2891 2.97852C21.6936 2.97852 22.0215 3.30645 22.0215 3.71094Z",
    fill: "#163235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0918 3.71094C19.0918 4.11543 18.7639 4.44336 18.3594 4.44336C17.9549 4.44336 17.627 4.11543 17.627 3.71094C17.627 3.30645 17.9549 2.97852 18.3594 2.97852C18.7639 2.97852 19.0918 3.30645 19.0918 3.71094Z",
    fill: "#163235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1621 3.71094C16.1621 4.11543 15.8342 4.44336 15.4297 4.44336C15.0252 4.44336 14.6973 4.11543 14.6973 3.71094C14.6973 3.30645 15.0252 2.97852 15.4297 2.97852C15.8342 2.97852 16.1621 3.30645 16.1621 3.71094Z",
    fill: "#163235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10547 11.0352H16.8945",
    stroke: "#163235",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17578 13.9648H19.8242",
    stroke: "#163235",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83789 18.3594C8.83789 19.1684 9.49375 19.8242 10.3027 19.8242H14.6973C15.5063 19.8242 16.1621 19.1684 16.1621 18.3594C16.1621 17.5504 15.5063 16.8945 14.6973 16.8945H10.3027C9.49375 16.8945 8.83789 17.5504 8.83789 18.3594Z",
    stroke: "#163235",
    strokeWidth: 1.55,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.0f05ccd41d95e78ae26b9410c00f03b0.svg";
export { ForwardRef as ReactComponent };